export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const CHANGE_PASSWORD_START='CHANGE_PASSWORD_START';
export const CHANGE_PASSWORD_SUCCESS='CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL='CHANGE_PASSWORD_FAIL';

export const SET_FIRST_TIME_PASSWORD_CHANGED = 'SET_FIRST_TIME_PASSWORD_CHANGED';